export namespace ExceptionWithDebuggingHint {
    /**
     * Generated from com.dataiku.dip.exceptions.ExceptionWithDebuggingHint$DebuggingHint
     */
    export enum DebuggingHint {
        CHECK_JOB_LOG = 'CHECK_JOB_LOG',
        CHECK_BACKEND_LOG = 'CHECK_BACKEND_LOG'
    }
}